import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Parcelcertificate = ({
  parcelCommune, setParcelCommune,
  parcelNumPage, setParcelNumPage,
  parcelNumTimbre, setParcelNumTimbre,
  parcelNameOfficer, setParcelNameOfficer,
  parcelNameQuartier, setParcelNameQuartier,
  parcelNamesOwner, setParcelNamesOwner,
  parcelCityBirthOwner, setParcelCityBirthOwner,
  parcelDateBirthOwner, setParcelDateBirthOwner,
  parcelProfessionOwner, setParcelProfessionOwner,
  parcelAvenueOwner, setParcelAvenueOwner,
  parcelNumAvenueOwner, setParcelNumAvenueOwner,
  parcelQuartierOwner, setParcelQuartierOwner,
  parcelCityMadeIn, setParcelCityMadeIn,
  parcelDateMadeIn, setParcelDateMadeIn,
  parcelNumDossier, setParcelNumDossier,
  parcelAttestationNum, setParcelAttestationNum, // New field for attestation number
  parcelAttestationDate, setParcelAttestationDate, // New field for attestation date
  addParcelCertificate, resp
}) => {
  const navigate = useNavigate();

  const convertDateFormat = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') return '';
    try {
      const [year, month, day] = dateStr.split('-');
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error('Erreur lors de la conversion de la date:', error);
      return dateStr;
    }
  };

  return (
    <div className="parente formResidence">
      <div className="formResidence__container container">
        {resp && (
          <div className="pop">
            <div className="pop__container">
              Formulaire bien soumis, Félicitations.
            </div>
          </div>
        )}
        <div className="formResidence__card__links">
          <Link to='/forms' className="formResidence__card__link">Retour en arrière</Link>
          <div className="formResidence__card__link formResidence__bar"> - </div>
          <Link className="formResidence__card__link">Formulaire Certificat Parcellaire</Link>
        </div>
        <h2 className="formResidence__title">Formulaire Certificat Parcellaire</h2>
        <div className="formResidence__banner">
          <form onSubmit={addParcelCertificate} className="parente__form">
            <h2 className="parente__title__sub">Formulaire</h2>
            <div className="parente__top__ville">
              Commune de <input type="text" value={parcelCommune} onChange={(e) => setParcelCommune(e.target.value)} placeholder='Nom de la Commune' className="parente__input" />
              Numéro de la page P.No : <input type="text" value={parcelNumPage} onChange={(e) => setParcelNumPage(e.target.value)} placeholder='Numéro de la page' className="parente__input" />
              Numéro vignette H.No : <input type="text" value={parcelNumTimbre} onChange={(e) => setParcelNumTimbre(e.target.value)} placeholder='Numéro de la vignette' className="parente__input" />
            </div>
            <p className="parente__spa">
              Je soussigné, <input type="text" value={parcelNameOfficer} onChange={(e) => setParcelNameOfficer(e.target.value)} placeholder="Nom complet de l'Officier" className="parent__input" />
              Chef du quartier <input type="text" value={parcelNameQuartier} onChange={(e) => setParcelNameQuartier(e.target.value)} placeholder="Nom du Quartier" className="parent__input" />,
            </p>
            <p className="parente__spa">
              atteste et confirme par la présente que la parcelle sise Avenue
              <input type="text" value={parcelAvenueOwner} onChange={(e) => setParcelAvenueOwner(e.target.value)} placeholder="Nom de l'avenue" className="parent__input" /> N°
              <input type="text" value={parcelNumAvenueOwner} onChange={(e) => setParcelNumAvenueOwner(e.target.value)} placeholder="Numéro de l'avenue" className="parent__input" />,
              Quartier <input type="text" value={parcelQuartierOwner} onChange={(e) => setParcelQuartierOwner(e.target.value)} placeholder="Nom du Quartier" className="parent__input" />
              dans la Commune de <input type="text" value={parcelCommune} onChange={(e) => setParcelCommune(e.target.value)} placeholder="Nom de la Commune" className="parent__input" />,
            </p>
            <p className="parente__spa">
              appartient à Monsieur/Madame/Mademoiselle <input type="text" value={parcelNamesOwner} onChange={(e) => setParcelNamesOwner(e.target.value)} placeholder="Nom du Propriétaire" className="parent__input" />,
              né(e) à <input type="text" value={parcelCityBirthOwner} onChange={(e) => setParcelCityBirthOwner(e.target.value)} placeholder="Ville de naissance du Propriétaire" className="parent__input" />,
              le <input type="date" value={convertDateFormat(parcelDateBirthOwner)} onChange={(e) => setParcelDateBirthOwner(convertDateFormat(e.target.value))} placeholder="Date de naissance du Propriétaire" className="parent__input" />,
              de profession <input type="text" value={parcelProfessionOwner} onChange={(e) => setParcelProfessionOwner(e.target.value)} placeholder="Profession du Propriétaire" className="parent__input" />,
            </p>
            <p className="parente__spa">
              suivant les documents en sa possession, notamment :
              <br />
              1. Acte de vente gré à gré du <input type="date" value={convertDateFormat(parcelDateMadeIn)} onChange={(e) => setParcelDateMadeIn(convertDateFormat(e.target.value))} placeholder="Date de l'acte de vente" className="parent__input" />,
              <br />
              2. Photocopie de la fiche parcellaire & de l'attestation de confirmation n° <input type="text" value={parcelAttestationNum} onChange={(e) => setParcelAttestationNum(e.target.value)} placeholder="Numéro de l'attestation" className="parent__input" />
              du <input type="date" value={convertDateFormat(parcelAttestationDate)} onChange={(e) => setParcelAttestationDate(convertDateFormat(e.target.value))} placeholder="Date de l'attestation" className="parent__input" /> du vendeur, de la fiche parcellaire du 1er occupant en sa possession,
              <br />
              3. Ainsi que les renseignements issus du fichier du bureau du quartier.
            </p>
            <p className="parente__spa">
              sous le N° <input type="text" value={parcelNumDossier} onChange={(e) => setParcelNumDossier(e.target.value)} placeholder="Numéro du dossier" className="parent__input" />
            </p>
            <br />
            <p className="parente__spa">
              Fait à <input type="text" value={parcelCityMadeIn} onChange={(e) => setParcelCityMadeIn(e.target.value)} placeholder="Ville de rédaction" className="parent__input" />,
              le <input type="date" value={convertDateFormat(parcelDateMadeIn)} onChange={(e) => setParcelDateMadeIn(convertDateFormat(e.target.value))} placeholder="Date du jour" className="parent__input" />
            </p>
            <div className="parente__btns">
              <button type='submit' className="parente__btn">Soumettre</button>
              <button type='reset' className="parente__btn">Annuler</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Parcelcertificate;